/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { useNotificationsStyles } from '../Notifications.styles';

type TwoSwitchesRowProps = {
  notificationNameText: string;
  common?: boolean;
  firstSwitch: React.ReactNode;
  secondSwitch: React.ReactNode;
};

export function TwoSwitchesRow(props: TwoSwitchesRowProps) {
  const { firstSwitch, common, notificationNameText, secondSwitch } = props;
  const classes = useNotificationsStyles();
  return (
    <>
      <div className={common ? classes.commonNotifications : classes.notificationName}>{notificationNameText}</div>
      <div className={classes.notificationType}>{firstSwitch}</div>
      <div className={classes.notificationType}>{secondSwitch}</div>
    </>
  );
}
